import AdminCategoryAdd from './AdminCategoryAdd';
export default AdminCategoryAdd;
